/* eslint-disable react-hooks/exhaustive-deps */


import React, { useEffect, useState } from 'react';
import { TableCell, TableRow, Typography, TextField, Table, Collapse, TableBody, Box, Button } from '@mui/material';
import { Image, Space, Dropdown, Menu } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { featureComponentHead } from "../../../../../config/constant";
import { useDispatch, useSelector } from "react-redux";
import { emptyValidation } from "../../../../../helpers/validation";
import { NavLink } from "react-router-dom";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import clsx from "clsx";
import DropDownSort from "../../../../../assets/images/icon_actions/DropDownSort.svg";
import DropDownSort1 from "../../../../../assets/images/icon_actions/DropDownSort1.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import crudActions from "../../../../CRUD/redux/actions";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import usePrevious from "../../../../Shared/components/Previous";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { checkCRUDPermission, getColumnWidth } from '../../../../../helpers/utilities';
import { checkComponentPermission } from '../../../../../helpers/utilities';

const Component = (props) => {
    const { createLoader, createDetails, editDetails } = useSelector(state => state.crudReducer);
    const { onRequestSort, sortOrder, sortBy, loadMoreTask, loadTasks,
        details, loadMore,
        loadMoreContent,
        componentType, loadTasksOthers,
        component,
        changeComponentVisible, roleManagement,
        checkErrorComponent } = props;
    const [selected, setSelected] = useState([]);
    const [visible, setVisible] = useState(false);
    const [addMore, setAddMore] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [name, setName] = useState('');
    const [deleteFeatureModal, setDeleteFeatureModal] = useState(false);
    const [componentId, setComponentId] = useState(false);
    const [featureId, setFeatureId] = useState('');
    const [featureName, setFeatureName] = useState('');
    const classes = customStyles();
    const dispatch = useDispatch();

    const prevCreateDetails = usePrevious(createDetails);
    const prevEditDetails = usePrevious(editDetails);

    const [form, setForm] = useState({
        componentTypeId: "",
        component: '',
        featureId: ''
    });

    const [error, setError] = useState({
        componentTypeId: "",
        component: '',
        featureId: ''
    });

    const onEdit = (data) => {
        const selectedIndex = selected.indexOf(data.id);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = [data.id];
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        }
        setSelected(newSelected);
    }

    const emptyState = () => {
        setError({
            componentTypeId: "",
            component: '',
            featureId: ''
        });
    }

    const emptyStateInput = () => {
        setForm({
            componentTypeId: "",
            component: '',
            featureId: ''
        });
    }

    useEffect(() => {
        setError({
            ...error,
            component: checkErrorComponent
        });
    }, [checkErrorComponent]);

    const handleOpen = (data) => {
        setVisible(true);
        emptyStateInput();
        changeComponentVisible(true);
        setName(data?.featureName);
        setForm({
            ...form,
            featureId: data.id
        });
    };

    const handleClose = () => {
        setVisible(false);
        changeComponentVisible(false);
        emptyStateInput();
        emptyState();
    };

    const createComponent = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Component', form.component);
        let emptyFeatureId = emptyValidation('Feature', form.featureId);
        let emptyComponentTypeId = emptyValidation('Component Type', form.componentTypeId);
        emptyState();
        if (emptyName.isValid && emptyFeatureId.isValid && emptyComponentTypeId.isValid) {
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'featureComponents',
                title: 'Feature Components',
                details: form
            });
        } else {
            setError({
                'component': emptyName.errors,
                'featureId': emptyFeatureId.errors,
                'componentTypeId': emptyComponentTypeId.errors
            });
        }
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            handleClose();
            if (addMore) {
                setAddMore(false);
                // setTimeout(function () {
                //     handleOpen();
                // }, 500)
            }
        }
    }, [createDetails]);

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            setVisible(false);
        }
    }, [editDetails]);

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e,
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }

    };

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleAddMore = (e) => {
        createComponent(e);
        setAddMore(true);
    }

    const onComponentDelete = (data) => {
        setDeleteModal(true);
        setComponentId(data?.id);
        setName(data?.component);
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteFeatureModal(true);
        setFeatureName(data?.featureName);
        setFeatureId(data?.id);
    }

    return (
        <>
            <CustomInfiniteScroll
                heads={featureComponentHead}
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                loadMoreTask={loadMoreTask}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <React.Fragment key={`feature_${data.id}`}>
                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={classes.scrollParentIcons}>
                                                    <TableCell style={{ width: getColumnWidth(featureComponentHead, 0) }}>
                                                        <NavLink style={{ width: getColumnWidth(featureComponentHead, 0) }} to={"#"} onClick={() => onEdit(data)} className={clsx(classes.customLink)}>
                                                            <Image src={selected && selected.find(e => e === data.id) ? DropDownSort : DropDownSort1} preview={false} />
                                                            <Typography variant={'h6'} className={clsx(classes.typographyHeader, classes.LightBlue, classes.bold, classes.marginLeft10)}
                                                            >{data?.featureName}</Typography>
                                                        </NavLink></TableCell>
                                                    <TableCell style={{ width: getColumnWidth(featureComponentHead, 1) }}></TableCell>
                                                    <TableCell style={{ width: getColumnWidth(featureComponentHead, 2) }}></TableCell>
                                                    <TableCell>
                                                        {
                                                            selected && selected.find(e => e === data.id) ?
                                                                <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                                    {
                                                                        roleManagement !== '' && checkCRUDPermission('Module List', 'edit', 'Younote Admin') &&
                                                                        <NavLink to="#" className={clsx(classes.customLink)} onClick={() => handleOpen(data)}>
                                                                            <Image src={AddIcon} preview={false} className={clsx(classes.antImage)} /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Component</span>
                                                                        </NavLink>
                                                                    }
                                                                </Space> : <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                                    {
                                                                        roleManagement !== '' && checkCRUDPermission('Module List', 'edit', 'Younote Admin') &&
                                                                        <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                            <Image src={ViewIcon} preview={false} />
                                                                        </NavLink>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' && checkCRUDPermission('Module List', 'edit', 'Younote Admin') &&
                                                                        <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                            <Image src={EditIcon} preview={false} />
                                                                        </NavLink>
                                                                    }
                                                                    {
                                                                        roleManagement !== '' && checkCRUDPermission('Module List', 'edit', 'Younote Admin') &&
                                                                        <NavLink to={"#"} onClick={() => onDelete(data)}>
                                                                            <Image src={DeleteIcon} preview={false} />
                                                                        </NavLink>
                                                                    }
                                                                    <Dropdown
                                                                        trigger={['click']}
                                                                        placement={'bottomRight'}
                                                                        overlay={
                                                                            <Menu className={clsx(classes.groupMenu)}>
                                                                                <Menu.Item className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Module List', 'Ellipsis Action', 'Add Component') &&
                                                                                    <Menu.Item><NavLink to={'#'} onClick={() => handleOpen(data)}>Add Component</NavLink></Menu.Item>

                                                                                }
                                                                            </Menu>
                                                                        }>
                                                                        <Image src={ElipsisIcon} preview={false} />
                                                                    </Dropdown>
                                                                </Space>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={classes.scrollParentIcons}>
                                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
                                                        <Collapse className={classes.collapseTable} in={selected && selected.find(e => e === data.id) ? true : false} timeout="auto" unmountOnExit>
                                                            <Table size="small" aria-label="purchases">
                                                                <TableBody>
                                                                    {
                                                                        component && component.length > 0 && component.filter(component => component.featureId === data.id).map((data, i) => (
                                                                            <TableRow key={`component_${data.componentId}`}>
                                                                                <TableCell style={{ width: getColumnWidth(featureComponentHead, 0) }}></TableCell>
                                                                                <TableCell style={{ width: getColumnWidth(featureComponentHead, 1) }}>{data?.component}</TableCell>
                                                                                <TableCell style={{ width: getColumnWidth(featureComponentHead, 2) }}>
                                                                                    {
                                                                                        componentType && componentType.length > 0 && componentType.filter(ct => ct.id === data.componentTypeId).map(filteredType => (
                                                                                            <React.Fragment key={filteredType.id}>
                                                                                                {filteredType.componentType}
                                                                                            </React.Fragment>
                                                                                        ))
                                                                                    }
                                                                                </TableCell>
                                                                                <TableCell style={{ width: "30%" }}>
                                                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                                                        {
                                                                                            roleManagement !== '' && checkCRUDPermission('Module List', 'edit', 'Younote Admin') &&
                                                                                            <NavLink to={"#"} onClick={() => onComponentDelete(data)}>
                                                                                                <Image src={DeleteIcon} preview={false} />
                                                                                            </NavLink>
                                                                                        }
                                                                                    </Space>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                </TableBody>
                                                            </Table>
                                                        </Collapse>
                                                    </TableCell>
                                                </TableRow>
                                            </React.Fragment>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Add Component'}
                width={'360px'}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createComponent(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Feature</Typography>

                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{name}</Typography>
                            <TextField autoComplete='one-time-code'
                                label={["Component ", <span key={"Component"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                error={error.component ? true : false}
                                helperText={error.component}
                                name={"component"}
                                className={classes.margin30t}
                                value={form.component}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                onChange={(e) => changeHandler(e)}
                            />
                            <AutoCompleteComponent
                                name={["Select Component Type ", <span key={"Select Component Type"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'componentType', 'name': 'Name' }]}
                                details={componentType}
                                parentValue={customObject(componentType, form.componentTypeId)}
                                onChange={(data) => changeHandler(data.id, "componentTypeId")}
                                position={"bottom"}
                                customClasses={classes.margin30t}
                                parentError={error.componentTypeId}
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Space direction="horizontal" align="center" size={[10, 10]}>
                                <Button
                                    key="save"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}
                                >
                                    Save & Close
                                </Button>
                                <Button
                                    key="add"
                                    onClick={(e) => handleAddMore(e)}
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}>
                                    Add more
                                </Button>
                            </Space>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} loadTasks={() => loadTasks()} name={name} id={componentId} url={'featureComponents'} title={'Feature Components'} visible={deleteModal} />

            <DeleteModal onClose={(v) => setDeleteFeatureModal(v)} loadTasks={() => loadTasksOthers()} name={featureName} id={featureId} url={'features'} title={'Feature'} visible={deleteFeatureModal} />
        </>
    )
}

export default Component